import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../../client';


export type CollaborativeProviderDetails = {
  id: string;
  user: {
    id: string;
    firstName: string;
    lastName: string;
    email: string | null;
  };
  collaborativeStateIds: string[];
  licenseStateIds: string[];
  currentCaseload: number;
};


export const getAllCollaborativeProvidersDetails = (physicianId: string) => restClient.request<{ data: CollaborativeProviderDetails[] }>(
  `/api/v1/physician/${physicianId}/supervisees`
);

export const getCollaborativeProviderDetails = (providerId: string) => restClient.request<{ data: CollaborativeProviderDetails }>(
  `/api/v1/provider/${providerId}/supervisee-details`
);


export enum CollaborativeProviderActivityType {
  supervisionMeeting = 'supervision_meeting',
  chartsReviewPending = 'charts_review_pending',
  chartsReviewCompleted = 'charts_review_completed',
  agreementSigned = 'agreement_signed',
}


export type BaseCollaborativeProviderActivity<T extends CollaborativeProviderActivityType> = {
  activityType: T;
  id: string;
  datetime: string;
};
export type ChartsReviewPendingCollaborativeProviderActivity = BaseCollaborativeProviderActivity<CollaborativeProviderActivityType.chartsReviewPending>;
export type ChartsReviewCompletedCollaborativeProviderActivity = BaseCollaborativeProviderActivity<CollaborativeProviderActivityType.chartsReviewCompleted> & {
  reviewId: string;
  stateId: string;
};
export type SupervisionMeetingCollaborativeProviderActivity = BaseCollaborativeProviderActivity<CollaborativeProviderActivityType.supervisionMeeting> & {
  stateId: string;
  durationMinutes: string;
  summary: string;
};
export type AgreementSignedCollaborativeProviderActivity = BaseCollaborativeProviderActivity<CollaborativeProviderActivityType.agreementSigned> & {
  reviewId: string;
  stateId: string;
};
export type CollaborativeProviderActivity = (
  ChartsReviewPendingCollaborativeProviderActivity
  | ChartsReviewCompletedCollaborativeProviderActivity
  | SupervisionMeetingCollaborativeProviderActivity
  | AgreementSignedCollaborativeProviderActivity
);

export type GetCollaborativeProviderActivityFilters = {
  cursor?: string;
  stateId?: string;
};
export const getCollaborativeProviderActivity = (providerId: string, filters?: GetCollaborativeProviderActivityFilters) => restClient.request<{ data: CollaborativeProviderActivity[]; cursor: string }>(
  `/api/v1/provider/${providerId}/collaborative-activity`,
  {
    params: filters ? snakecaseKeys(filters) : undefined,
  }
);
